import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/themetwo/back.png'
import _imports_1 from '@/assets/themetwo/f2.png'


const _hoisted_1 = { class: "notice_container" }
const _hoisted_2 = { class: "titleHead" }
const _hoisted_3 = ["innerHTML"]

import CustomHeader from '@/components/common/customHeader.vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'errorNotice',
  emits: ['goToHome'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const goToHome = () => {
    emits('goToHome')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "headIcon" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        onClick: goToHome
      })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_1,
      alt: ""
    }, null, -1)),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('notice.updateNotification')), 1),
    _createElementVNode("div", {
      innerHTML: _ctx.$t('notice.contentText')
    }, null, 8, _hoisted_3)
  ]))
}
}

})